import { useSearchParams } from "react-router-dom"

export default function ParameterizedErrorPage({ errorMsg }: { errorMsg?: string }) {
  const [searchParams] = useSearchParams()
  const errorMessage = errorMsg || searchParams.get("message") || "An error occurred. Please try again later."

  return (
    <section>
      <div className="h-screen w-screen bg-gray-100">
        <div className="h-full w-full">
          <div className="flex flex-col justify-center items-center h-full w-full">
            <div className="flex flex-col justify-center items-center">
              <img src="/vibrato-logo-alt.svg" className="h-[40px] lg:h-[60px] min-w-fit mb-8" />
              <div className="text-2xl font-bold text-gray-700 text-center">Oops, something went wrong!</div>
              <div className="text-xl font-normal text-gray-700 mt-4 max-w-md text-center mx-auto">{errorMessage}</div>
              <div className="text-xl font-normal text-gray-700 mt-4 max-w-md text-center mx-auto">
                For assistance, contact us at{" "}
                <a href="mailto:contact@getvibrato.com" className="text-blue-500 hover:underline">
                  contact@getvibrato.com
                </a>
              </div>

              <div className="mt-8 w-full max-w-xs flex flex-col gap-4">
                <button
                  onClick={() => (window.location.href = "/dashboard")}
                  className="w-full py-3 px-4 rounded-lg bg-white border border-gray-200 shadow-sm text-gray-700 font-medium flex items-center justify-center gap-2 transition-all hover:bg-gray-50 active:scale-98 focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                    <polyline points="9 22 9 12 15 12 15 22" />
                  </svg>
                  Go Home
                </button>
                <button
                  onClick={() => (window.location.href = "/logout")}
                  className="w-full py-3 px-4 rounded-lg bg-white border border-gray-200 shadow-sm text-red-600 font-medium flex items-center justify-center gap-2 transition-all hover:bg-gray-50 active:scale-98 focus:outline-none focus:ring-2 focus:ring-red-500"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                    <polyline points="16 17 21 12 16 7" />
                    <line x1="21" x2="9" y1="12" y2="12" />
                  </svg>
                  Log Out
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
